import React, { FunctionComponent, ReactNode } from "react";
import { Alert, Text, Title } from "@gjensidige/builders-components";

interface Props {
  title?: string;
  text?: ReactNode;
  severity?: "success" | "informative" | "warning" | "error";
  eventLabel?: string;
}

const FormAlert: FunctionComponent<Props> = ({ severity, text, title, eventLabel }) => {
  const eventLabelParsed = eventLabel || (title ? title.toLowerCase().replaceAll(' ', '-') : 'default-alert-label');
  return (
    <Alert severity={severity} style={{ whiteSpace: "pre-line" }} tracking={{eventLabel: eventLabelParsed}}>
      {title && <Title>{title}</Title>}
      {text && <Text>{text}</Text>}
    </Alert>
  );
};

export default FormAlert;
